module.exports = __webpack_public_path__ + "img/T240多功能水面无人船.47006f20.png";